@import url("https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@300;400&display=swap");

html,
body,
#root {
  height: 100%;
}

a {
  text-decoration: none;
  color: inherit;
}

a.underline-link {
  text-decoration: underline;

  &:hover {
    text-decoration: none;
  }
}

label {
  font-size: 12px;
}

.App {
  height: 100%;
  /* overflow-y: auto; */
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Spinner */
.spinner {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 80px;
  height: 80px;
}

.spinner div {
  position: absolute;
  width: 6px;
  height: 6px;
  background: #c5c5c5;
  border-radius: 50%;
  animation: spinner 1.2s linear infinite;
}

.spinner div:nth-child(1) {
  animation-delay: 0s;
  top: 37px;
  left: 66px;
}

.spinner div:nth-child(2) {
  animation-delay: -0.1s;
  top: 22px;
  left: 62px;
}

.spinner div:nth-child(3) {
  animation-delay: -0.2s;
  top: 11px;
  left: 52px;
}

.spinner div:nth-child(4) {
  animation-delay: -0.3s;
  top: 7px;
  left: 37px;
}

.spinner div:nth-child(5) {
  animation-delay: -0.4s;
  top: 11px;
  left: 22px;
}

.spinner div:nth-child(6) {
  animation-delay: -0.5s;
  top: 22px;
  left: 11px;
}

.spinner div:nth-child(7) {
  animation-delay: -0.6s;
  top: 37px;
  left: 7px;
}

.spinner div:nth-child(8) {
  animation-delay: -0.7s;
  top: 52px;
  left: 11px;
}

.spinner div:nth-child(9) {
  animation-delay: -0.8s;
  top: 62px;
  left: 22px;
}

.spinner div:nth-child(10) {
  animation-delay: -0.9s;
  top: 66px;
  left: 37px;
}

.spinner div:nth-child(11) {
  animation-delay: -1s;
  top: 62px;
  left: 52px;
}

.spinner div:nth-child(12) {
  animation-delay: -1.1s;
  top: 52px;
  left: 62px;
}

@keyframes spinner {
  0%,
  20%,
  80%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.5);
  }
}

.full-details-table > .ReactVirtualized__Grid:focus {
  outline: 0;
}

.full-details-table > .ReactVirtualized__Grid::-webkit-scrollbar {
  width: 0.4em;
  height: 0.4em;
}

.full-details-table > .ReactVirtualized__Grid::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px #eceff1;
  box-shadow: inset 0 0 6px #eceff1;
}

.full-details-table > .ReactVirtualized__Grid::-webkit-scrollbar-thumb {
  background-color: #90a4ae;
}

.full-details-table > .ReactVirtualized__Grid::-webkit-scrollbar-thumb:hover {
  background-color: #216bc7;
}

@media screen and (max-width: 800px) {
  .App {
    overflow-x: hidden;
  }
}

.handsontable .colored {
  background: rgba(255, 205, 0, 0.3);
}

.handsontable .markedForDeletion {
  background: rgba(255, 0, 0, 0.1);
}

.handsontable .error {
  background: rgba(255, 0, 0, 0.3);
}

.leaflet-div-icon {
  background: transparent;
  border: none;
}

/* .ag-center-aligned-header {
  display: flex;
  align-items: center;
} */

.ag-center-aligned-header .ag-header-cell-label .ag-header-cell-text {
  display: flex;
  justify-content: center;
  width: 100%;
}

.bold {
  font-weight: 500;
}

.ResizeHandleOuter {
  flex: 0 0 10px;
  position: relative;
  outline: none;
  background-color: transparent;
  border-radius: 10px;
}

.ResizeHandleInner {
  position: absolute;
  top: 0.25em;
  bottom: 0.25em;
  left: 0.25em;
  right: 0.25em;
  border-radius: 0.25em;
  transition: background-color 0.2s linear;
}

.Icon {
  width: 1em;
  height: 1em;
  position: absolute;
  left: calc(50% - 0.5rem);
  top: calc(50% - 0.5rem);
}
